// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C0_rWrinqJC9ZoMj5kCm {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/pricing/DefaultPricing/DefaultPricing.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb","sourcesContent":[".default-pricing {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-pricing": "C0_rWrinqJC9ZoMj5kCm"
};
export default ___CSS_LOADER_EXPORT___;
